import {
    Component, EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';

@Component({
    selector: 'app-user-icon-list',
    templateUrl: './user-icon-list.component.html',
    styleUrls: ['./user-icon-list.component.css']
})

export class UserIconListComponent implements OnInit {
    @Input() usersList: any;
    @Input() imageList: any [];
    @Input() isGridCell: any;
    @Input() useInitialsFallback: boolean = false;
    constructor() { }

    ngOnInit() {
    }

    ngOnChanges(){
    }

    getInitials(name: string): string {
        if (!name) {
            return '';
        }
        return name
            .split(' ')
            .map(word => word.charAt(0))
            .join('')
            .toUpperCase()
            .slice(0, 2);
    }
}
